// Capacitor 네이티브 브리지. 웹에선 안전하게 no-op/폴백.
// 플러그인은 웹 구현이 있어 import는 웹에서도 안전.

import { Capacitor } from "@capacitor/core";
import { Haptics, ImpactStyle } from "@capacitor/haptics";
import { Share } from "@capacitor/share";
import { Filesystem, Directory } from "@capacitor/filesystem";
import { Media } from "@capacitor-community/media";

export function isNative(): boolean {
  return Capacitor.isNativePlatform();
}

const ALBUM = "Hyuh";

// Android는 savePhoto에 albumIdentifier가 필수 → "Hyuh" 앨범을 찾거나 만들어 식별자 반환.
async function androidAlbumId(): Promise<string | undefined> {
  if (Capacitor.getPlatform() !== "android") return undefined;
  const { albums } = await Media.getAlbums();
  let a = albums.find((x) => x.name === ALBUM);
  if (!a) {
    await Media.createAlbum({ name: ALBUM });
    a = (await Media.getAlbums()).albums.find((x) => x.name === ALBUM);
  }
  return a?.identifier;
}

/** 키프세이크 카드 PNG를 기기 갤러리에 저장. */
export async function nativeSaveImage(dataUrl: string): Promise<boolean> {
  if (!isNative()) return false;
  try {
    const albumIdentifier = await androidAlbumId();
    await Media.savePhoto({ path: dataUrl, albumIdentifier, fileName: `hyuh-${Date.now()}` });
    return true;
  } catch {
    return false;
  }
}

/** 키프세이크 카드 PNG를 네이티브 공유 시트로(이미지 파일 첨부). 캐시에 쓰고 file URI를 공유.
 *  url은 안 넘긴다 — 넘기면 일부 타깃이 '링크 공유'로 처리해 이미지를 떨군다. 링크는 text 안에 둔다. */
export async function nativeShareImage(dataUrl: string, text: string): Promise<boolean> {
  if (!isNative()) return false;
  try {
    const base64 = dataUrl.includes(",") ? dataUrl.split(",")[1] : dataUrl;
    const name = `hyuh-${Date.now()}.png`;
    const { uri } = await Filesystem.writeFile({ path: name, data: base64, directory: Directory.Cache });
    await Share.share({ title: "Hyuh", text, files: [uri], dialogTitle: "Hyuh" });
    return true;
  } catch (e) {
    console.error("nativeShareImage failed:", e);
    return false;
  }
}

/** 제출/강림 순간의 부드러운 햅틱. */
export function hapticSoft(): void {
  if (!isNative()) return;
  Haptics.impact({ style: ImpactStyle.Light }).catch(() => {});
}
